import React, { useEffect, useState } from 'react';
import {
    fetchEmployeesList,
    deleteEmployee,
    fetchPortsList,
    fetchDesignationsList,
    getEmployeeTargets,
    createEmployeeTarget,
    fetchPortAvailableCount,
    savePortAvailableCount,
} from './services/api';
import { Employee, Designation, Port } from './types';
import { useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Button, Image, Form, Row, Col } from 'react-bootstrap';
import { useAuth } from './AuthContext';

const PortAvailableCount: React.FC = () => {
    const [portsAvailableCount, setPortsAvailableCount] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [savingId, setSavingId] = useState<number | null>(null);

    // 🔹 Target values per employee
    const [targets, setTargets] = useState<Record<number, number | ''>>({});

    const navigate = useNavigate();
    const { token } = useAuth();

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                const response = await fetchPortAvailableCount();
                setPortsAvailableCount(response);

                const initialTargets: Record<number, number | ''> = {};
                response.forEach((data: any) => {
                    if ((data as any).available_count !== undefined) {
                        initialTargets[data.port_id] = (data as any).available_count;
                    }
                });
                console.log(initialTargets);
                setTargets(initialTargets);
            } catch (error) {
                setError('Failed to load available count');
            }
        };
        loadInitialData();
    }, [token]);

    const handleTargetChange = (id: number, value: string) => {
        setTargets(prev => ({
            ...prev,
            [id]: value === '' ? '' : Number(value),
        }));
    };

    const handleSaveTarget = async (data: any) => {
        const targetValue = targets[data.port_id];

        if (targetValue === '' || targetValue === undefined) {
            alert('Please enter count value');
            return;
        }

        setSavingId(data.employee_id);
        try {
            // 🔹 Replace with real API
            await savePortAvailableCount({ port_id: data.port_id, available_count: targetValue });
            alert('Count saved successfully');
        } catch (error) {
            alert('Failed to save count');
        } finally {
            setSavingId(null);
        }
    };

    return (
        <div className="p-4 p-md-5">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="mb-0">Agreed Manpower</h2>

            </div>
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="table-responsive">
                <table className="table table-bordered align-middle">
                    <thead className="table-light">
                        <tr>
                            <th>Port</th>
                            <th>Agreed Manpower</th>
                            <th style={{ width: 140 }}>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            Array.from({ length: 5 }).map((_, i) => (
                                <tr key={i}>
                                    {Array.from({ length: 10 }).map((__, j) => (
                                        <td key={j}>
                                            <Skeleton height={20} />
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : portsAvailableCount.length === 0 ? (
                            <tr>
                                <td colSpan={10} className="text-center">
                                    No data found.
                                </td>
                            </tr>
                        ) : (
                            portsAvailableCount.map(e => (
                                <tr key={e.port_id}>
                                    <td>{e.port_name}</td>
                                    <td>
                                        <Form.Control
                                            type="number"
                                            size="sm"
                                            min={0}
                                            value={targets[e.port_id] ?? ''}
                                            onChange={ev =>
                                                handleTargetChange(e.port_id, ev.target.value)
                                            }
                                        />
                                    </td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-outline-success me-2"
                                            onClick={() => handleSaveTarget(e)}
                                            disabled={
                                                savingId === e.port_id || targets[e.port_id] === '' || targets[e.port_id] === undefined
                                            }
                                        >
                                            {savingId === e.port_id ? (
                                                <span className="spinner-border spinner-border-sm" />
                                            ) : (
                                                <i className="fas fa-save" />
                                            )}
                                        </button>

                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PortAvailableCount;
